import { environment } from "../constants/environment";
import { getBrowserName } from "../utils/browserName";
import { getDeviceType } from "../utils/deviceType";
import { queryParams } from "../config/queryParams";

const locationId: string = queryParams.locationId;

export const trackPage = (stepDetails: any): boolean =>
  document.dispatchEvent(
    new CustomEvent("c-tracking-log-page", {
      bubbles: true,
      detail: {
        page: {
          category: {
            businessType: "resi",
            designType: "responsive",
            primaryCategory: "help & support",
            siteType: "selfservice",
            subCategory1: `store appointment`, //metaData.itgName
          },
          codebase: {
            name: "h&s av resi",
          },
          pageInfo: {
            browserName: getBrowserName(),
            deviceType: getDeviceType(),
            language: "en",
            locationId: locationId || "",
            pageName: `resi|selfservice|help & support|store appointment|${stepDetails?.pageName?.toLowerCase()}|${locationId}`,
            screenName: stepDetails?.pageName?.toLowerCase(),
          },
        },
        shared: {
          sessionId: sessionStorage.getItem("ev_sessionId"),
        },
        siteInfo: {
          server: environment,
        },
      },
    })
  );
